import { HttpClient } from "@angular/common/http";
import { Inject, Injectable, Optional } from "@angular/core";
import { ENVIRONMENT, Environment } from "@vattenfall/core";
import { FinnishProductDetailsModel } from "src/app/flows/shared/services/finnish-product-details.model";

@Injectable({
  providedIn: "root",
})
export class FinnishProductDetailsService {
  constructor(
    private http: HttpClient,
    @Optional()
    @Inject(ENVIRONMENT)
    private environment: Environment
  ) {}
  get(productId: string, campaignCode: string) {
    /**
     * Build the query parameters for the product call
     * and filter out undefined paramenters.
     */
    const queryParameters = new URLSearchParams(
      Object.entries({
        languageCode: this.environment.language,
        campaignCode: campaignCode,
      }).filter(([_key, value]) => !!value) // Filter out undefined values.
    ).toString();
    return this.http.get<FinnishProductDetailsModel>(
      `${this.environment.endpoints.acquisitionApi}/products/${productId}?${queryParameters}`
    );
  }
}
